import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import style from './index.less';

const RequiredText = ({ value, className, required }) => {
  return (
    <div className={classNames(style.mainContainer, style.antFormItemLabel, 'ant-col ant-form-item-label pb-0.5')}>
      <label title={value} className={classNames(className, { 'ant-form-item-required': required })}>
        {value}
      </label>
    </div>
  );
  
};

RequiredText.propTypes = {
  required: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.string
};

RequiredText.defaultProps = {
  required: true
};

export default memo(RequiredText);
